import { __rest, __assign, __values } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { Box } from '../../Box/index.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside.js';
import { useTheme } from '../../hooks/useTheme.js';
import { LayoutScreenProvider, useLayoutScreenContext } from './LayoutScreenContext.js';

var LayoutScreenInner = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var _b = useLayoutScreenContext(), sidebar = _b.sidebar, header = _b.header;
    var layoutScreenRef = useRef(null);
    var forwardProps = handleStyleProps(props, { themeKey: "layoutScreen" });
    var sidebarObserver = new ResizeObserver(function (entries) {
        var e_1, _a;
        if (layoutScreenRef.current) {
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var entry = entries_1_1.value;
                    layoutScreenRef.current.style.setProperty("--layout-sidebar-width", "".concat(entry.contentRect.width, "px"));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    });
    var headerObserver = new ResizeObserver(function (entries) {
        var e_2, _a;
        if (layoutScreenRef.current) {
            try {
                for (var entries_2 = __values(entries), entries_2_1 = entries_2.next(); !entries_2_1.done; entries_2_1 = entries_2.next()) {
                    var entry = entries_2_1.value;
                    layoutScreenRef.current.style.setProperty("--layout-header-height", "".concat(entry.contentRect.height, "px"));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (entries_2_1 && !entries_2_1.done && (_a = entries_2.return)) _a.call(entries_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    });
    useEffect(function () {
        if (sidebar.ref.current) {
            sidebarObserver.observe(sidebar.ref.current);
        }
        if (header.ref.current) {
            headerObserver.observe(header.ref.current);
        }
    }, []);
    useOnClickOutside([sidebar.ref, header.sidebarToggleButtonRef], function () { return sidebar.setIsOpen(false); });
    return (jsx(Box, __assign({ "data-component": "LayoutScreen", ref: layoutScreenRef }, forwardProps, { children: children })));
};
var LayoutScreen = function (_a) {
    var sidebarDefaultIsOpen = _a.sidebarDefaultIsOpen, props = __rest(_a, ["sidebarDefaultIsOpen"]);
    return (jsx(LayoutScreenProvider, __assign({ sidebarDefaultIsOpen: sidebarDefaultIsOpen }, { children: jsx(LayoutScreenInner, __assign({}, props)) })));
};

export { LayoutScreen };
//# sourceMappingURL=LayoutScreen.js.map
